import React, { useRef, useState } from 'react';
import { Upload } from 'lucide-react';

interface ImageDropzoneProps {
  onFilesSelected: (files: File[]) => void;
  hint?: string;
}

/** Dropzone de imágenes múltiples con el mismo look & feel que ImageUpload (solo-portada). */
export const ImageDropzone: React.FC<ImageDropzoneProps> = ({
  onFilesSelected,
  hint = 'PNG, JPG hasta 5MB',
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = (fileList: FileList | null) => {
    if (!fileList || fileList.length === 0) return;
    const files = Array.from(fileList).filter((f) => f.type.startsWith('image/'));
    if (files.length > 0) onFilesSelected(files);
  };

  return (
    <div
      onClick={() => inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragEnter={(e) => {
        e.preventDefault();
        setIsDragging(true);
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        setIsDragging(false);
      }}
      onDrop={(e) => {
        e.preventDefault();
        setIsDragging(false);
        handleFiles(e.dataTransfer.files);
      }}
      className={`relative w-full border-2 border-dashed rounded-lg flex flex-col items-center justify-center cursor-pointer py-8 transition-colors ${
        isDragging ? 'border-accent bg-accent/10' : 'border-gray-300 hover:border-accent bg-gray-50'
      }`}
    >
      <Upload className={`w-10 h-10 mb-2 ${isDragging ? 'text-accent' : 'text-gray-400'}`} />
      <p className={`text-sm mb-1 ${isDragging ? 'text-accent font-medium' : 'text-gray-600'}`}>
        {isDragging ? 'Suelta las imágenes aquí' : 'Haz clic o arrastra imágenes aquí'}
      </p>
      <p className="text-xs text-gray-500">{hint}</p>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        onChange={(e) => {
          handleFiles(e.target.files);
          e.target.value = '';
        }}
        className="hidden"
      />
    </div>
  );
};
